<template lang="pug">
  .how-to.xs-12
    FixedWidthTweakUpper
      SectionLink(url="/dashboard/how-to/custom-instructions" link-text="Personalized Instructions" data-mr-ass="personalized-instructions")
      SectionLink(url="/how-to-color-your-hair" link-text="How To Color Your Hair" :vue-route="false")
      SectionLink(url="/how-to-highlight" link-text="How To Highlight" :vue-route="false")
      ExpertiseIncluded

</template>

<script>
  import ExpertiseIncluded from '../../ExpertiseIncluded';
  import SectionLink from "../SectionLink";
  import FixedWidthTweakUpper from "../../FixedWidthTweakUpper";
  
  export default {
    components: {
      FixedWidthTweakUpper,
      SectionLink,
      ExpertiseIncluded
    }
  }
</script>

<style scoped lang="stylus">

</style>
